import moment, { type Moment } from 'moment-timezone';

/**
 * True when the calendar day is strictly after today (local timezone).
 * Use with Ant Design `disabledDate` on day-granularity pickers.
 */
export const isCalendarDayAfterToday = (current: Moment | null | undefined): boolean =>
  Boolean(current?.isAfter(moment(), 'day'));

/** Ant Design `disabledDate` — disables days after today. */
export const disableCalendarDatesAfterToday = (current: Moment | null): boolean =>
  isCalendarDayAfterToday(current);

/** Clips calendar dates while retaining the original historical start and inclusive today. */
export const clampCalendarRangeToToday = (
  range: [Moment, Moment],
  timeZone?: string,
  reference: Moment = moment(),
): [Moment, Moment] => {
  const today = timeZone ? reference.clone().tz(timeZone) : reference.clone();
  const todayKey = today.format('YYYY-MM-DD');
  const [start, end] = range;
  const clippedStart = start.format('YYYY-MM-DD') > todayKey ? today.clone().startOf('day') : start;
  const clippedEnd = end.format('YYYY-MM-DD') > todayKey ? today.clone().endOf('day') : end;
  return [clippedStart, clippedEnd];
};
